module.exports = __webpack_public_path__ + "img/add.0ef26e7f.svg";